/*
    Handles dynamic image import to components via global $images instance of Vue.
    Import every image here and add to images object
*/

import check from '@/assets/icons/check.svg'
import smallPlus from '@/assets/icons/plus-small.svg'
import plus from '@/assets/icons/plus.svg'
import mail from '@/assets/icons/mail.svg'
import mailWhite from '@/assets/icons/mail_white.svg'
import notifications from '@/assets/icons/notifications.svg'
import search from '@/assets/icons/search.svg'
import arrowRight from '@/assets/icons/arrow-right.svg'
import logo from '@/assets/icons/logo.png'
import facebookB from '@/assets/icons/facebook-black.png'
import twitterB from '@/assets/icons/twitter-black.png'
import linkedinB from '@/assets/icons/linkedIN-black.png'
import websiteB from '@/assets/icons/world-black.png'
import mailB from '@/assets/icons/mail-black.png'
import phoneB from '@/assets/icons/phone-black.png'
import calendly from '@/assets/icons/calendly.png'
import flag from '@/assets/icons/flag.png'
import publicIcon from '@/assets/icons/public-icon-yellow.png'
import publicIconBlack from '@/assets/icons/public-icon.png'
import messageIcon from '@/assets/icons/message-icon-yellow.png'
import messageIconBlack from '@/assets/icons/message-icon.png'
import chooseChat from '@/assets/icons/choose-chat.png'
import profileIcon from '@/assets/icons/profile-icon.png'
import reportIcon from '@/assets/icons/report-icon.png'
import sendIcon from '@/assets/icons/send-icon.png'
import home from '@/assets/icons/home.svg'
import floor from '@/assets/icons/floor.svg'
import lecture from '@/assets/icons/lecture.svg'
import agenda from '@/assets/icons/agenda.svg'
import job from '@/assets/icons/job.png'
import location from '@/assets/icons/location.png'
import uni from '@/assets/icons/uni.png'
import stockAvatar from '@/assets/icons/stock-avatar.png'
import sendIconB from '@/assets/icons/send-icon-black.png'
import collectiVibeLogo from '@/assets/icons/collectivibe-logo.png'
import collectiVibeLogoGrayscale from '@/assets/icons/collectivibe-logo-grayscale.png'
import marsLogo from '@/assets/icons/mars-logo.png'
import meeting from '@/assets/icons/meeting.png'
import dropdownArrow from '@/assets/icons/dropdown_arrow.png'
import angryAnimation from '@/assets/emoji/shy.gif'
import angry from '@/assets/emoji/shy.png'
import surpriseAnimation from '@/assets/emoji/clap.gif'
import surprise from '@/assets/emoji/clap.png'
import likeAnimation from '@/assets/emoji/like.gif'
import like from '@/assets/emoji/like.png'
import sadAnimation from '@/assets/emoji/party_popper.gif'
import sad from '@/assets/emoji/party_popper.png'
import squintAnimation from '@/assets/emoji/squint.gif'
import squint from '@/assets/emoji/squint.png'
import heartAnimation from '@/assets/emoji/heart.gif'
import heart from '@/assets/emoji/heart.png'
import googleLogo from '@/assets/icons/google-logo.svg'
import call from '@/assets/icons/call.png'
import notificationsWhite from "@/assets/icons/notifications_white.svg";
import volumeOff from '@/assets/icons/volume-off.png'
import volumeOn from '@/assets/icons/volume-on.png'
import phoneOverlay from '@/assets/backgrounds/phoneOverlay.png'
import ics from '@/assets/icons/ics.png'
import googleCalendar from '@/assets/icons/google-calendar.png'
import phoneCall from '@/assets/icons/phone-call.png'
import blueTick from '@/assets/icons/blue-tick.png'
import loader from '@/assets/loader.svg'
import eucStep3 from '@/assets/backgrounds/euc-step3.png'
import carouselArrow from '@/assets/icons/carouselArrow.png'
import twitter from '@/assets/icons/footer_icons/tweet.png'
import linkedin from '@/assets/icons/footer_icons/linked.png'
import instagram from '@/assets/icons/footer_icons/insta.png'
import youtube from '@/assets/icons/footer_icons/yt.png'
import facebook from '@/assets/icons/footer_icons/face.png'
import attachment from '@/assets/icons/attachment.svg'

const images = {
    youtube,
    twitter,
    linkedin,
    facebook,
    instagram,
    blueTick,
    phoneOverlay,
    likeAnimation,
    angryAnimation,
    sadAnimation,
    squintAnimation,
    surpriseAnimation,
    heartAnimation,
    like,
    angry,
    sad,
    squint,
    surprise,
    heart,
    check,
    smallPlus,
    plus,
    mail,
    notifications,
    search,
    arrowRight,
    logo,
    facebookB,
    twitterB,
    linkedinB,
    websiteB,
    mailB,
    phoneB,
    calendly,
    flag,
    publicIcon,
    publicIconBlack,
    messageIcon,
    messageIconBlack,
    chooseChat,
    profileIcon,
    reportIcon,
    sendIcon,
    sendIconB,
    home,
    floor,
    lecture,
    agenda,
    job,
    uni,
    location,
    stockAvatar,
    collectiVibeLogo,
    collectiVibeLogoGrayscale,
    marsLogo,
    meeting,
    dropdownArrow,
    googleLogo,
    call,
    volumeOff,
    volumeOn,
    ics,
    googleCalendar,
    phoneCall,
    loader,
    eucStep3,
    mailWhite,
    notificationsWhite,
    carouselArrow,
    attachment,
}

export default images